import { FC } from 'react';
import { LayoutBlock } from '../LayoutBlock';
import { Chips, UIHeading1, UIText1 } from '@cian/ui-kit';
import { IPikHistoryItem } from './internal/models/PikHistoryItem';

import styles from './PikHistory.css';

type PikHistory = {
  chipsOptions: IPikHistoryItem['chipsOption'][];
  activePikHistoryItem: IPikHistoryItem;
  onChange: (value: string[]) => void;
};

export const PikHistory: FC<PikHistory> = ({ chipsOptions, activePikHistoryItem, onChange }) => {
  return (
    <LayoutBlock title="История компании" id="pik-history">
      <div className={styles['container']}>
        <Chips<string>
          options={chipsOptions}
          dataTestId="history-chips"
          value={[activePikHistoryItem.chipsOption.value]}
          onChange={onChange}
        />
        <div className={styles['content']}>
          <span data-testid="history-title" className={styles['title']}>
            {activePikHistoryItem.chipsOption.label}
          </span>
          <div data-testid="history-content" className={styles['main-text-container']}>
            <UIHeading1 data-testid="history-content-title">{activePikHistoryItem.title}</UIHeading1>
            <UIText1 data-testid="history-content-description">{activePikHistoryItem.description}</UIText1>
          </div>
        </div>
      </div>
    </LayoutBlock>
  );
};
